export const color_option_url: string = "color_option";